import { defineStore } from 'pinia'

export const useSidebar = defineStore('sidebar', {
    state: () => {
        return {
            openDialog: false,
            timeout: null
        }
    },

    actions: {
        show(options=null) {
            this.$reset();
            this.openDialog = true;

            if (options && options['timeout']) {
                this.timeout = options['timeout'];
            }
        },

        hide() {
            this.openDialog = false;
        }
    }
})